import React from 'react';

/**
 * Gold-rimmed circular avatar medallion with optional dealer chip / active ring.
 */
export default function AvatarBadge({
  name,
  avatarUrl,
  isLocal = false,
  isActive = false,
  isDealer = false,
  ready = false,
}) {
  return (
    <div className={`cv2-avatar ${isLocal ? 'is-local' : ''}`} title={name}>
      {isActive && <div className="cv2-avatar-ring-active" />}
      {isDealer && <div className="cv2-dealer-chip" aria-label="Dealer">D</div>}
      <img
        src={avatarUrl || '/avatars/avatar1.png'}
        alt=""
        draggable={false}
      />
      {ready && (
        <span
          style={{
            position: 'absolute',
            bottom: 2,
            right: 2,
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: '#1f8a4c',
            border: '2px solid #fff',
          }}
          aria-label="Ready"
        />
      )}
    </div>
  );
}
